<script>
    import Button from "../Components/Button.svelte";
    import TextEditor from "../../Common/TextEditor.svelte";
    import {getStyleValue} from "../../Common/tools"

    export let data, meta, globalStyle, onChange;

    function change(value) {
      onChange();
      data = Object.assign({}, data, {content: value});
    }
</script>
<tr>
    <th>
        <table>
            <tr>
              {#if !data.switched}
                  <th class="column mobile-12" style="padding-left: 40px; padding-right: 10px;"
                      width="{getStyleValue(globalStyle.width, 600)*0.4}">
                      <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                  </th>
                  <th class="column mobile-12 mobile-padding-top"
                      style="padding-left: 10px; padding-right: 40px; text-align: left;"
                      width="{getStyleValue(globalStyle.width, 600)*0.6}">
                      <TextEditor bind:data={data.content} meta={meta} onChange={change} emailEditor={true} />
                  </th>
              {:else}
                  <th class="column mobile-12" style="padding-left: 40px; padding-right: 10px; text-align: left;"
                      width="{getStyleValue(globalStyle.width, 600)*0.6}">
                      <TextEditor bind:data={data.content} meta={meta} onChange={change} emailEditor={true} />
                  </th>
                  <th class="column mobile-12 mobile-padding-top"
                      style="padding-left: 10px; padding-right: 40px;"
                      width="{getStyleValue(globalStyle.width, 600)*0.4}">
                      <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                  </th>
              {/if}
            </tr>
        </table>
    </th>
</tr>